import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'components/organisms/mlb-hitter-stacking/actions';
import StackItem from './stack-item';
import {generateRandomKey} from 'helpers/hash';

class TeamStack extends Component {
    getRangeHitterPositions() {
        const {sportConfig} = this.props;

        return sportConfig.getConfigProp('rangeHitterPositions', []);
    }

    getRangePositions() {
        return this.getRangeHitterPositions().map((item) => {
            return (
                <option key={item} value={item}>
                    {item}
                </option>
            );
        });
    }

    setPlayersInGroup(groupNumber = null, value = null) {
        this.props.dispatch(Action.setHitterStackPayersInGroup(groupNumber, value));
    }

    addItem() {
        const {groupNumber} = this.props;
        this.props.dispatch(Action.addHittersStackItem(groupNumber));
    }

    render() {
        const {groupNumber, stack} = this.props;
        const rangePositions = this.getRangePositions();
        const group = stack.getGroup(groupNumber);

        return (
            <div className="team-stack">
                <h3>STACK {groupNumber}</h3>
                <div className="form-inline">
                    <strong className="form-sub-text">Stack {groupNumber} players</strong>
                    <select
                        value={group.playersQuantity}
                        onChange={(e) => ::this.setPlayersInGroup(groupNumber, e.target.value)}
                        className="form-control input-sm"
                    >
                        {rangePositions}
                    </select>
                </div>
                <div className="gap-y">
                    {group.items.map((item, index) => {
                        return (
                            <StackItem
                                key={generateRandomKey()}
                                item={item}
                                groupNumber={groupNumber}
                                itemNumber={index}
                            />
                        );
                    })}
                </div>
                <div className="text-right">
                    <button type="submit" onClick={::this.addItem} className="btn">
                        Add team
                    </button>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, stacks} = state;

    return {
        sportConfig,
        stack: stacks.hitters,
    };
}

export default connect(mapStatesToProps)(TeamStack);
